<template>
    <elevator-drawer class="displayRackClassifyDrawer" :title="'设置展架分类'" :visible="visible" size="700px" @close="close"
        @open="open">
        <div class="search">
            <el-input class="search-input" v-model="classifyName"></el-input>
            <el-button type="primary" @click="search(1)">查询</el-button>
            <el-button @click="clearSearchCondition">清空</el-button>
        </div>
        <div class="operate-btn">
            <el-button @click="addClassify">新增分类</el-button>
        </div>

        <el-table ref="table" class="classify-table" :data="tableList" :row-key="'id'" style="width: 100%" :tree-props="treeProps">
            <el-table-column prop="index" label="序号">
            </el-table-column>
            <el-table-column prop="name" label="分类名称">
            </el-table-column>
            <el-table-column prop="operate" label="操作" width="220">
                <template slot-scope="{row}">
                    <el-button v-if="row.level == '1'" @click.native.prevent="addNextLevel(row, tableList)" type="link">
                        添加下级
                    </el-button>
                    <el-button @click.native.prevent="edit(row, tableList)" type="link">
                        编辑
                    </el-button>
                    <el-button @click.native.prevent="deleteRow(row, tableList)" type="link">
                        删除
                    </el-button>
                </template>
            </el-table-column>
            <el-table-column prop="sort" label="排序" width="180">
                <template slot-scope="{row}">
                    <el-button v-if="!row.isFirst" @click.native.prevent="moveUp(row, tableList)" type="link">
                        上移
                    </el-button>
                    <el-button  v-if="!row.isLast" @click.native.prevent="moveDown(row, tableList)" type="link">
                        下移
                    </el-button>
                    <el-button v-if="!row.isFirst" @click.native.prevent="topUp(row, tableList)" type="link">
                        置顶
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <!-- 翻页 -->
        <div class="pagination-container">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="page.pageNo"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="page.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="total"
            ></el-pagination>
        </div>
        <!-- <span slot="footer">
            <el-button @click="close">取消</el-button>
            <el-button type="primary" @click="save">保存</el-button>
        </span> -->
        <AddClassifyDialog v-if="addClassifyDialogVisible" :rowData="rowData" :type="addType"
            :visible="addClassifyDialogVisible" @ok="addClassifyOk" @close="addClassifyDialogVisible = false">
        </AddClassifyDialog>
        <EditClassifyDialog v-if="editClassifyDialogVisible" :editData="rowData" :visible="editClassifyDialogVisible"
            @ok="editClassifyOk" @close="editClassifyDialogVisible = false"></EditClassifyDialog>
    </elevator-drawer>
</template>

<script>
import ElevatorDrawer from '@components/common/ElevatorDrawer.vue';
import AddClassifyDialog from './addClassifyDialog.vue';
import EditClassifyDialog from './editClassifyDialog.vue';
import {
    queryBaseItemDisplay,
    deleteDisplayClassify,
    setTopDisplayClassify,
    moveToDisplayClassify,
} from '@servers/base/display/index.js';
import { formatList, searchByKeyword } from './common.js'
import { cloneDeep } from "lodash";
import { deepClone } from '@/print/components/PrintProfessional/print_util';
import { mapActions, mapGetters, mapState } from '@pages/supplier/commodity/components/List/store'

export default {
    components: {
        ElevatorDrawer,
        AddClassifyDialog,
        EditClassifyDialog
    },
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
        data: Object,
    },
    watch: {
    },
    data () {
        return {
            classifyName: '',
            addType: '1',
            editData: {},
            page: {
                pageNo: 1,
                pageSize: 10,
            },
            total: 0,
            treeProps: {
                children: "list",
                hasChildren: "hasChildren"
            },
            orginTableList:[],//原始数据
            tableList: [],//表格数据
            checkedAll: false, // 是否全选
            addClassifyDialogVisible: false,
            editClassifyDialogVisible: false
        };
    },
    computed: {
    },
    created () {
        this.search();
    },
    methods: {
        ...mapActions(['queryDisplayRackClassifyList']),

        async handleSizeChange (pageSize) {
            this.page.pageSize = pageSize;
            this.page.pageNo = 1;
            await this.$nextTick();
            this.getTableData();
        },
        async handleCurrentChange (pageNo) {
            this.page.pageNo = pageNo;
            await this.$nextTick();
            this.getTableData()
        },
        getTableData () {
            let data = deepClone(this.orginTableList);
            const { pageNo, pageSize } = this.page;
            this.tableList = data.slice((pageNo - 1) * pageSize, pageNo * pageSize);
            if(this.classifyName){
                this.openTable();
            }
        },
        /**
         * 查询
         */
        async search (type) {
            if (type == 1) {
                //点击查询按钮需要重置pageNo = 1
                this.page.pageNo = 1;
            }
            try {
                const list = await queryBaseItemDisplay();
                if (list) {
                    let tableList = [];
                    if (this.classifyName) {
                        tableList = searchByKeyword(this.classifyName, list);
                    } else {
                        tableList = formatList(list);
                    }
                    this.orginTableList = tableList;
                    this.total = tableList.length;
                    const { pageNo, pageSize } = this.page;
                    this.tableList = tableList.slice((pageNo - 1) * pageSize, pageNo * pageSize);
                    console.log('tableList', tableList);
                    if (this.classifyName) {
                        this.openTable()
                    }
                }
            } catch {
               console.error('异常')
            }
        },
        async openTable(){
            await this.$nextTick();
            this.handleArr(this.tableList, true);
        },
        handleArr (arr, flag) {
           arr.forEach(item => {
               this.$refs.table.toggleRowExpansion(item, flag);
               if (item.list) {
                    this.handleArr(item.list,flag)
               }
           }); 
        },
        /**
         * 清空条件
         */
        async clearSearchCondition () {
            this.classifyName = '';
            console.log('清空条件');
            await this.$nextTick();
            this.search();
        },
        addClassify () {
            console.log('新增分类');
            this.addType = '1';
            this.rowData = {};
            this.addClassifyDialogVisible = true;
        },
        /**
         * 添加下级
        */
        addNextLevel (row) {
            console.log('添加下级');
            this.addType = '2';
            this.rowData = row;
            this.addClassifyDialogVisible = true;
        },
        /**
         * 编辑
        */
        edit (row) {
            console.log('编辑');
            this.editClassifyDialogVisible = true;
            this.rowData = row;
        },
        /**
         * 删除当前分类
        */
        deleteRow (row, table) {
            this.$confirm('确定删除此分类吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                const params = {
                    id: row.id,
                };
                const res = await deleteDisplayClassify(params);
                if (res) {
                    this.$message({
                        type: 'success',
                        message: '删除成功!'
                    });
                    this.search();
                }
            }).catch(() => {
                console.log('取消删除');
            });
        },
        /**
         * 上移
         */
        async moveUp (row) {
            const params = {
                id: row.id,
                type: 1,
                targetId: this.getBrotherId(row,1),
            };
            console.log('上移：', params);
            const res = await moveToDisplayClassify(params);
            if (res) {
                this.$message({
                    type: 'success',
                    message: '操作成功!'
                });
                this.search(); 
            } 
        },
        /**
         * 下移
        */
        async moveDown (row) {
            const params = {
                id: row.id,
                type: 1,
                targetId: this.getBrotherId(row,2),
            };
            console.log('下移：', params);
            const res = await moveToDisplayClassify(params);
            if (res) {
                this.$message({
                    type: 'success',
                    message: '操作成功!'
                });
                this.search(); 
            } 
        },
        async topUp (row) {
            const params = {
                id: row.id,
            };
            const res = await setTopDisplayClassify(params);
            if (res) {
                this.$message({
                    type: 'success',
                    message: '操作成功!'
                });
                this.search();
            }
        },
        /**
         * 打开Dialog时，初始化数据
         */
        async open () {

        },
        /**
         * 关闭Dialog
         * 需要清空数据
         */
        close () {
            this.queryDisplayRackClassifyList();
            this.$emit('close');
        },
        /**
         * 新增分类回调
         */
        addClassifyOk () {
            this.addClassifyDialogVisible = false;
            this.search();
        },
        /**
         * 编辑分类名回调
         */
        editClassifyOk () {
            this.editClassifyDialogVisible = false;
            this.search();
        },
        /**
         * 获取兄弟节点id
         * @param {*} type  1:上一个节点/2:下一个节点
         */
        getBrotherId (row,type='1') {
            let brotherId = '';
            const orginTableList = deepClone(this.orginTableList);
            if(row.level == 1){
                const res = this.orginTableList.some((item, i) => {
                    if (item.id == row.id) {
                        if (type == '1') {
                            brotherId = orginTableList[i-1].id;
                        }else{
                            brotherId = orginTableList[i+1].id;
                        }
                        return true;
                    } 
                    return false;
                });
            } else {
                const res = this.orginTableList.some((item, i) => {
                    return (item.list || []).some((el, j) => {
                        if (el.id == row.id) {
                            if (type == '1') {
                                brotherId = orginTableList[i].list[j - 1].id;
                            }else{
                                brotherId = orginTableList[i].list[j + 1].id;
                            }
                            return true;
                        }
                        return false;
                    })
                });
            }
            
            console.log('brotherId', brotherId);
            return brotherId;
        }
    },
};
</script>
<style lang="scss" scoped>
.displayRackClassifyDrawer {
    .search {
        margin-bottom: 20px;

        .search-input {
            display: inline-block;
            width: 200px;
            margin-right: 20px;
        }
    }

    .operate-btn {
        margin-bottom: 20px;
    }
    .classify-table{
        height: calc(100vh - 300px);
        overflow: auto;
    }
    .pagination-container{
        margin: 20px 0;
        text-align: right;
    }
}
</style>
